export const UPDATE_ALL = 'visitor/UPDATE_ALL';

interface UpdateAllAction {
    type: typeof UPDATE_ALL
    payload: any
}


export type visitorActionTypes = UpdateAllAction